import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px;
  padding-bottom: 0;
  overflow: hidden;
  flex: 1;
  min-height: 0;
`;

export const LoadingMessage = styled.p`
  color: var(--text-default);
  margin: 0;
  padding: 16px;
`;

export const ErrorMessage = styled.p`
  margin: 0;
  padding: 16px;
  color: var(--red--5);
`;
